import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import { Url, DYRUrl } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import SearchBar from "../../Components/UI-Controls/SearchBar/Search";
import searchIcon from "../../Assets/Images/Search Bar 20 x 20.png";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { CiWarning } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { IoImageOutline } from "react-icons/io5";
import { uploadImage } from "../../Services/functions";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";
import { IoClose } from "react-icons/io5";


const FloorsDYR = () => {
    const mainCategories = [
        {
            "_id": "686694202ac8d047299ea419",
            "uid": 1,
            "name": "Living Room",
            "slug": "bedroom"
        },
        {
            "_id": "686694482ac8d047299ea41c",
            "uid": 2,
            "name": "Bedroom",
            "slug": "berdroom"
        },
        {
            "_id": "6866946a2ac8d047299ea41f",
            "uid": 3,
            "name": "Dining Room",
            "slug": "dining-room",
        }
    ];

    const [selectedMainCategories, setSelectedMainCategories] = useState(["686694202ac8d047299ea419"]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [attrData, setAttrData] = useState({ name: "", title: "", image: "", imgId: "",categories:[] });
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [editId, setEditId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [modalView, setModalView] = useState(false);
    const [modaldata, setModalData] = useState([]);
    const [imageSendPayload, setImageSendPayload] = useState({
        file: null,
        alt_text: "",
        title: "",
        description: "",
        link_url: "",
    });
    const [uploadedStatus, setUploadedStates] = useState(null);

    const rowsPerPage = 10;

    const fetchTableData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${DYRUrl}/api/v1/floors/get`);
            setData(response.data.data || []);
            setToastMessage("Features fetched successfully!");
        } catch (error) {
            setToastMessage(`Failed to fetch features: ${error?.response?.data?.message || error.message}`);
        } finally {
            setLoading(false);
            setShowMessage(true);
        }
    };

    useEffect(() => { fetchTableData(); }, []);

    useEffect(() => {
        if (showMessage) {
            const timeout = setTimeout(() => setShowMessage(false), 3000);
            return () => clearTimeout(timeout);
        }
    }, [showMessage]);

    const handleSearch = (value) => setSearchTerm(value);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAttrData((prev) => ({
            ...prev,
            [name]: value,
            slug: name === "name" ? value.toLowerCase().replace(/\s+/g, "-") : prev.slug,
        }));
    };

    const handleGalleryModalOpen = () => setModalView(true);
    const handleGalleryModalClose = () => setModalView(false);

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const api = `${DYRUrl}/api/v1/media/add`;
            const imagePayloadToSend = new FormData();
            imagePayloadToSend.append("image", file);
            imagePayloadToSend.append("alt_text", imageSendPayload.alt_text);
            imagePayloadToSend.append("title", imageSendPayload.title);
            imagePayloadToSend.append("description", imageSendPayload.description);
            imagePayloadToSend.append("image_url", imageSendPayload.image_url);
            imagePayloadToSend.append("link_url", imageSendPayload.link_url);

            await uploadImage(imagePayloadToSend, api, setUploadedStates);
            await getApi();
        }
    };

    const handleImageSelect = (image) => {
        console.log(image)
        setAttrData((prev) => ({ ...prev, image: image.image_url, imgId: image._id }));
        handleGalleryModalClose();
    };

    const handleAddOrUpdate = async () => {
        const payload = { name: attrData.name, title: attrData.title, image: attrData.imgId,categories:selectedMainCategories };
        const apiCall = editId
            ? axios.put(`${DYRUrl}/api/v1/floors/${editId}`, payload)
            : axios.post(`${DYRUrl}/api/v1/floors/add`, payload);

        try {
            setLoading(true);
            await apiCall;
            setToastMessage(editId ? "Feature updated successfully!" : "Feature added successfully!");
            setAttrData({ name: "", title: "", image: "", imgId: "" ,categories:[]});
            setEditId(null);
            fetchTableData();
        } catch (error) {
            setToastMessage("An error occurred. Please try again.");
        } finally {
            setLoading(false);
            setShowMessage(true);
        }
    };

    const toggleDropdown = (uid) => {
        setOpenDropdownId((prevId) => (prevId === uid ? null : uid));
    };

    const handleAction = (action, row) => {
        setOpenDropdownId(null);
        if (action === "edit") {
            setEditId(row._id);
            setAttrData({ name: row.name, image: row.image.image_url, imgId: row.image._id,categories:row.categories });
            // setSelectedMainCategories(row.categories)
            setSelectedMainCategories(row.categories.map(cat => cat._id));
        } else if (action === "delete") {
            setCurrentRowId(row._id);
            setShowConfirm(true);
        }
    };

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            await axios.delete(`${DYRUrl}/api/v1/floors/${currentRowId}`);
            setToastMessage("Feature deleted successfully!");
            fetchTableData();
        } catch (error) {
            setToastMessage("Failed to delete. Please try again.");
        } finally {
            setIsLoading(false);
            setShowConfirm(false);
            setShowMessage(true);
        }
    };

    const handleCancel = async () => {
        setAttrData({ name: "", title: "", image: "", imgId: "" ,categories:[]});
        setEditId(null)
    }

    const filteredData = data.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const getApi = async () => {
        try {
            const response = await axios.get(`${DYRUrl}/api/v1/media/get`);
            setModalData(response.data.media);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => { getApi(); }, []);

    const columns = [
        {
            name: "Image",
            selector: (row) =>
                loading ? <ShimmerLoader width="125px" height="22.5px" borderRadius="20px" /> : (
                    <img width="auto" height="50px" src={DYRUrl + row.image?.image_url} alt="Feature" />
                ),
            minWidth: "200px",
            maxWidth: "450px",
        },
        {
            name: "Name",
            selector: (row) =>
                loading ? <ShimmerLoader width="125px" height="22.5px" borderRadius="20px" /> : row.name,
            minWidth: "150px",
            grow: 2, // Allows this column to grow more compared to others
            wrap: true, // Allows text to wrap on smaller screens
        },
        {
            name: "Action",
            cell: (row) =>
                loading ? <ShimmerLoader width="60px" height="22.5px" /> : (
                    <div>
                        <img
                            src={actionIcon}
                            alt="Actions"
                            width="40"
                            height="40"
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleDropdown(row._id)}
                        />
                        {openDropdownId === row._id && (
                            <div className="dropdown-menu show animate-dropdown-left">
                                <ul>
                                    <li onClick={() => handleAction("edit", row)}><FiEdit /> Edit</li>
                                    <li onClick={() => handleAction("delete", row)}><RiDeleteBin6Line /> Delete</li>
                                </ul>
                            </div>
                        )}
                    </div>
                ),
            minWidth: "100px",
            maxWidth: "130px",
        },
    ];


    return (
        <div className="ProductAttrPage">
            <div className="AttrSection-01">
                <span className="Section1-Leftside">Floors</span>
                <div className="Section1-Rightside-Updated">
                    <SearchBar
                        onSearch={handleSearch}
                        icon={searchIcon}
                        placeholder="Search Floor"
                    />
                </div>
            </div>

            <div className="AttrSection-02">
                <div className="Section2-Leftside">
                    <div className="Header">Add or Edit Floor</div>
                    <form
                        className="editor-form-dyr"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleAddOrUpdate();
                        }}
                    >
                        <div className="form-row">
                            <label>
                                Floor Name<span>*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={attrData.name}
                                onChange={handleInputChange}
                                required
                            />
                        </div>

                        <div className="form-row">
                            <label>
                                Category<span>*</span>
                            </label>
                            <div className="main_categories_dyr">
                                {mainCategories.map((category) => {
                                    const isSelected = selectedMainCategories.includes(category._id);

                                    return (
                                        <div
                                            key={category._id}
                                            onClick={() => {
                                                if (isSelected) {
                                                    setSelectedMainCategories(prev =>
                                                        prev.filter(id => id !== category._id)
                                                    );
                                                } else {
                                                    setSelectedMainCategories(prev => [...prev, category._id]);
                                                }
                                            }}
                                            className={isSelected ? "main_cat_com_dyr active" : "main_cat_com_dyr"}
                                        >
                                            {category.name}
                                        </div>
                                    );
                                })}

                            </div>
                        </div>



                        <div className="form-row">
                            <label>
                                Floor Image<span>*</span>
                            </label>
                            <div className="banner-upload">
                                {attrData.image ? (
                                    <div className="image-preview-wrapper">
                                        <img src={DYRUrl + attrData.image} alt="Thumbnail" />
                                        <button onClick={() => setAttrData((prev) => ({ ...prev, image: "", imgId: "" }))}>
                                            <IoClose size={20} />
                                        </button>
                                    </div>
                                ) : (
                                    <label className="upload-label" onClick={handleGalleryModalOpen}>
                                        <IoImageOutline size={45} />
                                        <span>Click to Upload Image</span>
                                    </label>
                                )}
                            </div>
                        </div>

                        <div className="SubmitBtn dyr">
                            {editId ? (
                                <>
                                    <button
                                        type="button"
                                        className="dyr-cancel-btn"
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="dyr-submit-btn"
                                    >
                                        Update
                                    </button>
                                </>
                            ) : (
                                <button
                                    type="submit"
                                    className="dyr-submit-btn"
                                >
                                    Add Floor
                                </button>
                            )}
                        </div>


                    </form>
                </div>

                <div className="Section2-Rightside dyr">
                    <DataTable columns={columns} data={paginatedData} />
                    <Pagination
                        activePageIndex={currentPage}
                        totalPages={totalPages}
                        onPrevPage={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                        onNextPage={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                        onPageChange={setCurrentPage}
                    />
                </div>
            </div>

            {showConfirm && (
                <div className="confirmation-modal">
                    <div className="Cat-modal-content">
                        <CiWarning className="warning-icon" />
                        <div>Are you sure you want to delete this Floor? This action cannot be undone.</div>
                        <div>
                            <button onClick={() => setShowConfirm(false)}>Cancel</button>
                            <CustomBtn
                                label={isLoading ? <div className="btn-loader-Category"></div> : "Confirm"}
                                onClick={handleDelete}
                                disabled={isLoading}
                            />
                        </div>
                    </div>
                </div>
            )}

            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => setShowMessage(false)}
            />

            <ImageGalleryPopup
                showImageGalleryPopUp={modalView}
                handleModalView={handleGalleryModalClose}
                handleFileChange={handleFileChange}
                onImageSelect={handleImageSelect}
                imageSendPayload={imageSendPayload}
                setImageSendPayload={setImageSendPayload}
                data={modaldata}
                getData={getApi}
                forDYR={true}
            />
        </div>
    );
};

export default FloorsDYR;
